<template>
    <div>
        <CFTitle title="8. Rezultate așteptate"></CFTitle>
        <b-table v-if="data && data.m3_project && data.m3_project.indicators && data.m3_project.indicators.indicators" striped hover :fields="fields" :items="items" class="custom-table">
            <template v-slot:cell(crt)="data">
                <span class="small-item-table">{{ data.index + 1 }}</span>
            </template>
            <template v-slot:cell(details)="data">
                <div class="position-relative flex">
                    <span v-if="!data.item.editing" class="small-item-table">{{ data.value }}</span>
                    <b-form-input v-else v-model="data.item.details" type="text"></b-form-input>
                    <div class="action-icons">
                        <b-icon-check-circle-fill v-if="data.item.editing" class="save-icon mr-2"
                                                  @click="saveResult(data.index)"
                        ></b-icon-check-circle-fill>
                        <b-icon-pencil-square v-else class="edit-icon mr-2"
                                              @click="editResult(data.index)"
                        ></b-icon-pencil-square>
                        <b-icon-x-circle-fill v-if="data.index > 0" class="delete-icon"
                                              @click="deleteResult(data.index)"
                        ></b-icon-x-circle-fill>
                    </div>
                </div>
            </template>
        </b-table>
        <M3Warn v-else type="red-warn" text="Te rugăm să completezi și să salvezi mai întâi datele din pagina "><template v-slot:link><router-link to="/aplicatii/m3-sketch/indicatori" style="margin-left: 10px; color: #ffffff; font-weight: 600">Indicatori</router-link></template></M3Warn>
        <a class="add-button mb-3" style="float: right" @click="addResult()">
            <p class="mr-3">Adaugă rezultat</p>
            <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
        </a>

        <hr style="margin-top: 70px;">
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte
        </b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import {
        BFormRadio,
        BTable,
        BFormCheckbox,
        BIconXCircleFill,
        BIconPlusCircleFill,
        BFormInput,
        BIconCheckCircleFill,
        BIconPencilSquare
    } from "bootstrap-vue";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import _ from "lodash";

    export default {
        components: {
            CFTitle,
            BFormRadio,
            BTable,
            BFormCheckbox,
            BIconXCircleFill,
            BIconPlusCircleFill,
            BIconCheckCircleFill,
            BIconPencilSquare,
            BFormInput,
            M3Warn
        },
        props: {
            m3GrantApplication: null,
            indicators: null,
            data: null,
            termeneV3: null
        },
        computed: {
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Rezultate așteptate')) {
                        this.completed = true
                    }
                },
                deep: true
            },
            m3GrantApplication: {
                handler () {
                    if (this.m3GrantApplication && this.m3GrantApplication.rezultate_asteptate)
                        this.items = this.m3GrantApplication.rezultate_asteptate
                },
                deep: true
            }
        },
        data() {
            return {
                completed: false,
                fields: [
                    {
                        key: 'crt',
                        label: 'Nr. crt',
                    },
                    {
                        key: 'details',
                        label: 'Detalii rezultat',
                    },
                ],
                items: []
            }
        },
        mounted() {
            if (this.m3GrantApplication && this.m3GrantApplication.rezultate_asteptate) {
                this.items = this.m3GrantApplication.rezultate_asteptate
            } else {
                // let produseText = ''
                if (this.data && this.data.m3_project && this.data.m3_project.indicators && this.data.m3_project.indicators.indicators) {
                    // COUNT ANGAJATI
                    let angajati2019 = ''
                    if (this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length > 0) {
                        let bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                        if(!this.data.m3_project.indicators && !this.data.m3_project.indicators.indicators.employees.number2019) {
                            angajati2019 = bilant2019[0].numar_mediu_angajati ? bilant2019[0].numar_mediu_angajati : 0
                        } else {
                            angajati2019 = this.data.m3_project.indicators.indicators.employees.number2019
                        }
                    }
                    let angajatiAsumati = this.data.m3_project.indicators.indicators.employees.number

                    let ca2019 = this.data.turnover;

                    // COUNT PRODUCTIVITATEA MUNCII
                    let productivitateaMuncii = this.data.m3_project.indicators.indicators.supResult[0].number

                    // COUNT PRODUSE
                    let produse = this.data.m3_project.indicators.indicators.supAchievement.number
                    // if (Number(produse) === 1) {
                    //     produseText = 'va fi realizat un produs/serviciu nou introdus pe piață'
                    // } else {
                    //     produseText = 'vor fi realizate ' + produse + ' produse/servicii noi introduse pe piață'
                    // }

                    this.items.push(
                        {
                            crt: 1,
                            details: '(editați) Modernizarea capacității de .... prin achiziția de ........ pentru ' + JSON.parse(localStorage.getItem('currentM3Company')).name,
                            editing: false
                        },
                        {
                            crt: 2,
                            details: 'În urma implementării proiectului, întreprinderea ' + JSON.parse(localStorage.getItem('currentM3Company')).name + ' sprijinită prin grantul în valoare de ' + this.indicators.nerambursabil.RON + ' lei, va fi pregătită pentru o redresare verde, digitală și rezilientă a economiei.Grantul primit permite lansarea ' + (Number(produse) === 1 ? 'unui nou produs/serviciu' : ('a ' + produse + ' produse/servicii')) + ' pe piață.',
                            editing: false
                        },
                        {
                            crt: 3,
                            details: 'În urma implementării proiectului, întreprinderea '+ JSON.parse(localStorage.getItem('currentM3Company')).name + ' sprijinită prin grantul în valoare de ' + this.indicators.nerambursabil.RON + ' lei își va crește productivitatea muncii în anul 3 de sustenabilitate cu  ' + productivitateaMuncii + '%',
                            editing: false
                        },
                    )
                    if(angajatiAsumati){
                        if(Number(angajati2019) === Number(angajatiAsumati)) {
                            this.items.push({
                                crt: 4,
                                details: 'Menținerea numărului de angajați în anul 3 de sustenabilitate de la '+ angajati2019 +' '+ this.getEmployeeString(angajati2019) + ' în anul 2019 la ' + Number(angajatiAsumati) + ' ' + this.getEmployeeString(angajatiAsumati) +' în anul 2026.',
                                editing: false
                            })
                        } else {
                            this.items.push({
                                crt: 4,
                                details: 'Creșterea numărului de angajați în anul 3 de sustenabilitate de la '+ angajati2019 +' '+ this.getEmployeeString(angajati2019) + ' în anul 2019 la ' + Number(angajatiAsumati) + ' ' + this.getEmployeeString(angajatiAsumati) +' în anul 2026.',
                                editing: false
                            })
                        }
                    }

                    if(productivitateaMuncii){
                        this.items.push({
                            crt: 5,
                            details: 'Creșterea cifrei de afaceri în anul 3 de sustenabilitate de la ' + this.formatPrice(ca2019) + ' lei în anul 2019 la minim ' + this.formatPrice(this.workProductivity(2026, angajati2019, ca2019, angajatiAsumati, productivitateaMuncii)) + ' lei în anul 2026',
                            editing: false
                        })
                    }
                }
            }
            if(this.finantareProgress && this.finantareProgress.includes('Rezultate așteptate')) {
                this.completed = true
            }
        },
        methods: {
            workProductivity(year, angajati2019, ca2019, angajatiAsumati, productivitateaMuncii){
                if(year === 2019){
                    return angajati2019 > 0 ? (ca2019 / angajati2019).toFixed(2) : 0
                } else if(year === 2026){
                    return (this.workProductivity(2019, angajati2019, ca2019, angajatiAsumati, productivitateaMuncii) * (Number(angajati2019) + Number(angajatiAsumati)) + (productivitateaMuncii/100) * (this.workProductivity(2019, angajati2019, ca2019, angajatiAsumati, productivitateaMuncii) * (Number(angajati2019) + Number(angajatiAsumati)))).toFixed(0)
                }
            },
            getEmployeeString(number) {
                if(Number(number) === 1) {
                    return 'angajat'
                } else if(Number(number) > 1 && Number(number) < 20) {
                    return 'angajați'
                } else if(Number(number) > 20) {
                    return 'de angajați'
                } else {
                    return 'angajați'
                }
            },
            formatPrice(price) {
                if(price)
                {
                    price = price.toString().replace('.', ',');
                    var pattern = /(-?\d+)(\d{3})/;
                    while (pattern.test(price))
                        price = price.replace(pattern, "$1.$2");
                    return price;
                }
            },
            sendForm() {
                if (this.completed) {
                    this.$store.dispatch('finantare/addToProgress', 'Rezultate așteptate')
                    axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application', {rezultate_asteptate: this.items})
                        .then(() => {
                            this.$toast.success('Informațiile au fost salvate!')
                            this.$emit('savedData')
                            this.$store.dispatch('finantare/addToProgress', 'Rezultate așteptate')
                        })
                } else {
                    this.$store.dispatch('finantare/removeFromProgress', 'Rezultate așteptate')
                }
            },
            addResult() {
                if (this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    let lastCrt = this.items[this.items.length - 1] ? this.items[this.items.length - 1].crt : 0
                    let itemEditing = false
                    this.items.forEach(item => {
                        if (item.editing) {
                            itemEditing = true
                        }
                    })
                    if (itemEditing) {
                        this.$toast.error('Salvează mai întâi rezultatul pe care îl editezi.')
                    } else {
                        this.items.push({crt: lastCrt + 1, details: '', editing: true})
                    }
                }
            },
            deleteResult(key) {
                if (this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    this.items.splice(key, 1)
                }

            },
            saveResult(key) {
                if (this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    this.items[key].editing = false
                }
            },
            editResult(key) {
                if (this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    this.items[key].editing = true
                }
            }
        }
    }
</script>

<style scoped>
.small-item-table {
    font-size: 13px;
}
.action-icons {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.delete-icon {
    color: var(--dangerColor);
}
.save-icon {
    color: var(--succesColor);
}
.flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
input {
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    max-width: 90%;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
</style>
